import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function OfferLetterView() {
  const [offerLetter, setOfferLetter] = useState(null);
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  // Get token from URL
  const token = window.location.pathname.split('/').pop();

  useEffect(() => {
    async function fetchOfferLetter() {
      setStatus('loading');
      try {
        const res = await fetch(`${API_URL}/api/admin/offer-letter/${token}`);
        const data = await res.json();
        if (data.success) {
          setOfferLetter(data.offerLetter);
          setStatus('loaded');
        } else {
          setStatus('error');
          setMessage(data.error || 'Offer letter not found');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Error loading offer letter');
      }
    }
    fetchOfferLetter();
  }, [token]);

  const handleApprove = async () => {
    setMessage('');
    try {
      const res = await fetch(`${API_URL}/api/admin/offer-letter/${token}/accept`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        setOfferLetter({ ...offerLetter, status: 'accepted' });
        setMessage('Offer letter accepted! You can now download your letter.');
      } else {
        setMessage(data.error || 'Failed to accept offer letter');
      }
    } catch (err) {
      setMessage('Error accepting offer letter');
    }
  };

  if (status === 'loading') return <div style={{ padding: 40, textAlign: 'center' }}>Loading offer letter...</div>;
  if (status === 'error') return <div style={{ padding: 40, textAlign: 'center', color: 'red' }}>{message}</div>;

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px #e5e7eb', padding: 32 }}>
      <h2 style={{ textAlign: 'center', marginBottom: 24 }}>Offer Letter</h2>
      <div style={{ marginBottom: 16 }}>
        <b>Name:</b> {offerLetter.name}<br />
        <b>S/o:</b> {offerLetter.so_name}<br />
        <b>Address:</b> {offerLetter.address}<br />
        <b>Company:</b> {offerLetter.company_name}<br />
        <b>Designation:</b> {offerLetter.designation}<br />
        <b>Location:</b> {offerLetter.location}<br />
        <b>Status:</b> <span style={{ color: offerLetter.status === 'accepted' ? 'green' : '#f39c12', fontWeight: 600 }}>{offerLetter.status}</span>
      </div>
      {/* Compensation Table */}
      {offerLetter.compensation && (
        <div style={{ marginBottom: 24 }}>
          <h3 style={{ margin: '16px 0 8px 0' }}>Compensation Details</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fafbfc', borderRadius: 8 }}>
            <tbody>
              {Object.entries(offerLetter.compensation).map(([key, value]) => (
                <tr key={key}>
                  <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', fontWeight: 500 }}>{key}</td>
                  <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* PDF Preview */}
      {offerLetter.pdf_url && (
        <div style={{ margin: '24px 0' }}>
          <iframe src={offerLetter.pdf_url} title="Offer Letter PDF" width="100%" height="400px" style={{ border: '1px solid #eee', borderRadius: 8 }}></iframe>
        </div>
      )}
      {offerLetter.status === 'pending' && (
        <button className="gogig-card-btn" style={{ width: '100%', marginBottom: 16 }} onClick={handleApprove}>Approve and Sign</button>
      )}
      {offerLetter.status === 'accepted' && offerLetter.pdf_url && (
        <a href={`${API_URL}/api/admin/offer-letter/${token}/download`} className="gogig-card-btn" style={{ width: '100%', textAlign: 'center', display: 'block' }} target="_blank" rel="noopener noreferrer">Download Offer Letter</a>
      )}
      {message && <div style={{ color: message.includes('accepted') ? 'green' : 'red', marginTop: 16 }}>{message}</div>}
    </div>
  );
} 